export default function CustomOptionSelect({ label, handleClick, value }) {
    return (
        <>
            <div className="flex items-center mb-5 select-none">
                <label className="w-28 inline-block text-right mr-4 text-gray-500">{label}</label>
                <div
                    className="flex justify-between rounded-lg border-2 border-gray-400 flex-1 p-2 placeholder-gray-300 outline-none focus:border-main-color"
                    onClick={handleClick}
                >
                    <div className="text-right" dangerouslySetInnerHTML={{__html: value}}>
                    </div>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                    </svg>
                </div>
            </div>
        </>
    )
}